export default function(el) {
    const content = document.querySelector(".p__blocks");
    const text = content.innerText;
    const wpm = 225;

    if (!text) return;

    const words = text.trim().split(/\s+/).length;
    const time = Math.ceil(words / wpm);

    el.innerText = `${time} min`;
}
